import { IconButton, Tooltip } from '@elkaso-app/web-design';
import { FiEdit } from 'react-icons/fi';

interface IErpActionsCell {
  restaurantId: number;
  supplierId: number;
  supplierType: string;
  onEditMappings: (restaurantId: number, supplierId: number, supplierType: string) => void;
}

export const ErpActionsCell: React.FC<IErpActionsCell> = ({
  restaurantId,
  supplierId,
  supplierType,
  onEditMappings,
}) => {
  return (
    <Tooltip label='Edit Mappings'>
      <IconButton
        aria-label='Edit mappings'
        icon={<FiEdit />}
        size='sm'
        colorScheme='blue'
        onClick={() => onEditMappings(restaurantId, supplierId, supplierType)}
      />
    </Tooltip>
  );
};
